module.exports = __webpack_public_path__ + "static/media/res8.c4fdc74a.PNG";